import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 10,
    seconds: 47
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          return {
            hours: 0,
            minutes: 10,
            seconds: 47
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-2xl md:text-4xl font-black text-[#FF6B35] tracking-wider" data-id="element-185">
      <div className="bg-black text-white px-3 py-2 rounded-md shadow-lg" data-id="element-186">
        {formatNumber(timeLeft.hours)}
      </div>
      <span className="text-black" data-id="element-187">:</span>
      <div className="bg-black text-white px-3 py-2 rounded-md shadow-lg" data-id="element-188">
        {formatNumber(timeLeft.minutes)}
      </div>
      <span className="text-black" data-id="element-189">:</span>
      <div className="bg-black text-white px-3 py-2 rounded-md shadow-lg" data-id="element-190">
        {formatNumber(timeLeft.seconds)}
      </div>
    </div>;
}